import React, { Component } from 'react'
import TickBox from './Tickbox'

export class FirstScreen extends Component {
    render() {
        return (
            <div className="incepem">
                <div className="m-header">
                    <span className="home-text">DEVELOPMENT TEST</span>
                </div>
                {/* <img alt="snake-small" className="m-white-snake" src={require("../../assets/imgs/mobile/snake.png")} /> */}

                <div className="m-tickboxesBox">
                    <TickBox text={"Do you ever wonder if your child is developing up to speed?"} />
                    <TickBox text={"Take our free 6 Areas of Development Test."} />
                    <TickBox text={"Get a detailed report of your child's current development status."} />
                </div>
                <div className="m-bullet-list">
                    <div className="m-bullet selected-bullet"></div>
                    <div className="m-bullet"></div>
                    <div className="m-bullet"></div>
                    <div className="m-bullet"></div>
                </div>
                <p onClick={this.props.nextStep} className="goNext">Next -></p>
            </div>
        )
    }
}

export default FirstScreen
